import React  from 'react'

import FieldProjects from "../projects"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"

type Props = {
    field       : FieldProjects
    model       : any;
    className?  : string;
    options?    : any
    onClick?    : onClick
};

export default function FieldProjects_View(props:Props) {

    const value = props.model[props.field.fieldId]

    return <SelectParentsNew className              = {props.className}
                             renderType             = {SelectParent_RenderType.INLINE_EDITABLE}
                             placeholder            = {props.field.placeholder}
                             parentsFor             = {props.field.parentsFor}
                             displayWorkspaceRoot   = {props.field.displayWorkspaceRoot}
                             projectIds             = {value}
                             disabled               = {true}/>

    /*return <SelectParent className={props.className}
                         renderValue="inline-editable"
                         parentsFor={props.field.parentsFor}
                         viewMode={props.field.viewMode}
                         multiselect={true}
                         placeholder={props.field.placeholder}
                         // unselectLabel={!!props.field.noValueOption ? props.field.noValueOptionLabel : null}
                         unselectLabel={props.field.noValueOptionLabel || null }
                         companies={[gd.companyId]}
                         values={value2}
                         showProjectIcon={true}
                         showIcon={true}
                         searchable={true}
                         disabled={true}/>*/
}
